import { render, staticRenderFns } from "./Examcopy.vue?vue&type=template&id=9a950e1e&"
import script from "./Examcopy.vue?vue&type=script&lang=js&"
export * from "./Examcopy.vue?vue&type=script&lang=js&"
import style0 from "./Examcopy.vue?vue&type=style&index=0&id=9a950e1e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports